export enum SellerBuyerStatus {
    /** 0 */
    ACTIVE = 'ACTIVE',
    /** 1 */
    PENDING = 'PENDING',
    /** 2 */
    INACTIVE = 'INACTIVE'
}
